<template>
    <div class="write-off-container">
        <div class="write-off-content" @click="handleClick('/write-off-order')">
            <div class="write-off-title">
                核销订单提货
            </div>
        </div>
        <div class="write-off-coupon" @click="handleClick('/write-off-coupon')">
            <div class="write-off-title">
                核销优惠券
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const activeTab = ref('write-off-order')

const handleClick = (path) => {
    activeTab.value = path
    router.push(path)
}
</script>

<style lang="less" scoped>
.write-off-container {
    min-height: 100vh;
    position: relative;
    background-image: url('../../assets/img/writeoff/write-off-2.png');
    background-size: 100% auto;
    background-position: top;
    background-repeat: no-repeat;
    margin-bottom: 13px;
    background-color: #FFFFFF;
    padding: 70px 17px 0px 17px;

    .write-off-content {
        background-image: url('../../assets/img/writeoff/write-off-1.png');
        background-size: 100% auto;
        background-position: top;
        background-repeat: no-repeat;
        height: 156px;
        border-radius: 8px;
        .write-off-title {
            font-size: 23px;
            font-weight: 500;
            color: #654317;
            font-family: 'PingFang SC-Semibold';
            line-height: 156px;
            padding-left: 32px;
        }
    }
    .write-off-coupon {
        background-image: url('../../assets/img/writeoff/write-off.png');
        background-size: 100% auto;
        background-position: top;
        background-repeat: no-repeat;
        height: 156px;
        border-radius: 8px;
        margin-top: 13px;
         .write-off-title {
            font-size: 23px;
            font-weight: 500;
            color: #155977;
            font-family: 'PingFang SC-Semibold';
            line-height: 156px;
            padding-left: 40px;
        }
    }
}
</style>